var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"WithOrWithoutConditions"},[_c('v-form',{ref:"form"},[_c('v-radio-group',{attrs:{"value":_vm.currentValues},on:{"change":_vm.update}},_vm._l((_vm.fieldsWithOrWithoutConditions.dataSource),function(option){return _c('v-radio',{key:option.name,attrs:{"label":option.name,"value":option.value}})}),1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }